import { lazy, Suspense } from 'react';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { ToastHost } from '../components/ui/ToastHost';
import { PwaUpdatePrompt } from '../components/ui/PwaUpdatePrompt';
import { GlobalShortcuts } from '../components/ui/GlobalShortcuts';

const ActionsPage = lazy(() =>
  import('../pages/ActionsPage').then((module) => ({ default: module.ActionsPage })),
);
const BattlePage = lazy(() =>
  import('../pages/BattlePage').then((module) => ({ default: module.BattlePage })),
);
const MonstersPage = lazy(() =>
  import('../pages/MonstersPage').then((module) => ({ default: module.MonstersPage })),
);
const PcsPage = lazy(() =>
  import('../pages/PcsPage').then((module) => ({ default: module.PcsPage })),
);
const SettingsPage = lazy(() =>
  import('../pages/SettingsPage').then((module) => ({ default: module.SettingsPage })),
);

const navigation = [
  { to: '/monsters', label: '怪物库' },
  { to: '/pcs', label: 'PC角色库' },
  { to: '/actions', label: '动作库' },
  { to: '/battle', label: '战斗' },
  { to: '/settings', label: '导入/导出' },
];

export function App() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <NavLink className="brand" to="/battle" aria-label="D&D 战斗助手首页">
          <span className="brand-dot" aria-hidden="true" />
          <strong>跑团辅助工具</strong>
        </NavLink>
        <nav className="main-nav" aria-label="主要导航">
          {navigation.map((item) => (
            <NavLink key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="page-shell">
        <Suspense fallback={<div className="route-loading">正在整理战场…</div>}>
          <Routes>
            <Route path="/battle" element={<BattlePage />} />
            <Route path="/monsters" element={<MonstersPage />} />
            <Route path="/pcs" element={<PcsPage />} />
            <Route path="/actions" element={<ActionsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/battle" replace />} />
          </Routes>
        </Suspense>
      </main>
      <ToastHost />
      <PwaUpdatePrompt />
      <GlobalShortcuts />
    </div>
  );
}
